/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import { School, SchoolYearData } from '@/types';
import scholenRepository from '../repositories/scholenRepository';

export default {
  /**
   * Returns leerlingenaantallen based on schoolJaren data
   */
  async getLeerlingAantallen(school: School) {
    if (!school) {
      throw Error('school required');
    }

    const { data: jaren } = await scholenRepository.listSchoolJaren({ 'where[school_id]': school.id }, school.type);
    const result: any = {};
    jaren.forEach((j) => {
      result[j.schooljaar] = j.leerlingaantal;
    });
    return result;
  },
  /**
   * Returns the ouderbijdrages based on schoolJaren data
   */
  async listSchoolOuderbijdrages(): Promise<SchoolOuderbijdrage[]> {
    const schoolOuderbijdrages: SchoolOuderbijdrage[] = [];
    const { data } = await scholenRepository.listSchoolJaren();
    for (const schoolYearData of data) {
      if (!schoolYearData.kosten || !schoolYearData.schooljaar) {
        continue;
      }
      schoolOuderbijdrages.push({
        schoolId: schoolYearData.school_id,
        schooljaar: schoolYearData.schooljaar,
        ouderbijdrage: schoolYearData.kosten,
        toelichting: schoolYearData.kosten_uitleg || '',
      });
    }
    return schoolOuderbijdrages;
  },

  async listSchoolKlimaten(scholen: School[]) {
    const result: any = {};
    const { data } = await scholenRepository.listSchoolJaren({}, 'vo');

    for (let i = 0; i < scholen.length; i += 1) {
      const school = scholen[i];
      const schoolData = data
        .filter((d: SchoolYearData) => d.school_id === school.id)
        .filter((d: SchoolYearData) => d.schoolklimaat)
        .sort((a: SchoolYearData, b: SchoolYearData) => {
          if (a.schooljaar > b.schooljaar) {
            return -1;
          }
          return 1;
        });
      result[school.id] = schoolData;
    }
    return result;
  },

  async listLeerlingoordelen(scholen: School[]) {
    const result: any = {};
    const { data } = await scholenRepository.listSchoolJaren({}, 'vo');

    for (let i = 0; i < scholen.length; i += 1) {
      const school = scholen[i];
      const schoolData = data
        .filter((d) => d.school_id === school.id)
        .filter((d) => d.leerlingoordeel) // remove empty jaren
        .sort((a, b) => {
          if (a.schooljaar > b.schooljaar) {
            return -1;
          }
          return 1;
        });
      result[school.id] = schoolData;
    }
    return result;
  },

  async listOuderoordelen(scholen: School[]) {
    const result: any = {};
    const { data } = await scholenRepository.listSchoolJaren({}, 'vo');

    for (let i = 0; i < scholen.length; i += 1) {
      const school = scholen[i];
      const schoolData = data
        .filter((d) => d.school_id === school.id)
        .filter((d) => d.ouderoordeel) // remove empty jaren
        .sort((a, b) => {
          if (a.schooljaar > b.schooljaar) {
            return -1;
          }
          return 1;
        });
      result[school.id] = schoolData;
    }
    return result;
  },
};

export type SchoolOuderbijdrage = {
  schoolId: string;
  schooljaar: string;
  ouderbijdrage: string;
  toelichting: string;
}
